export default {
  // --- VOTE INTENTION ---
  vote_intention: {
    type: "categorical",
    label: "Vote intention",
    category: "political",
    fulltext: "If a General Election were held tomorrow, which party would you vote for?",
    client: "all",
    keys: [
      "pol:vi:conservative:cat",
      "pol:vi:labour:cat",
      "pol:vi:libdem:cat",
      "pol:vi:reform:cat",
      "pol:vi:green:cat",
      "pol:vi:snp:cat",
      "pol:vi:plaid:cat",
      "pol:vi:other:cat",
      "pol:vi:dontknow:cat",
      "pol:vi:restore:cat"
    ],
    labels: {
      "pol:vi:conservative:cat": "Conservative",
      "pol:vi:labour:cat": "Labour",
      "pol:vi:libdem:cat": "Liberal Democrat",
      "pol:vi:reform:cat": "Reform UK",
      "pol:vi:green:cat": "Green",
      "pol:vi:snp:cat": "SNP",
      "pol:vi:plaid:cat": "Plaid Cymru",
      "pol:vi:restore:cat": "Restore",
      "pol:vi:other:cat": "Other",
      "pol:vi:dontknow:cat": "Don't know",
    },
    colors: {
      "pol:vi:conservative:cat": "#0087DC",
      "pol:vi:labour:cat":       "#D50000",
      "pol:vi:libdem:cat":       "#FDBB30",
      "pol:vi:reform:cat":       "#12B6CF",
      "pol:vi:green:cat":        "#008066",
      "pol:vi:snp:cat":          "#FFF95D",
      "pol:vi:plaid:cat":        "#3F8428",
      "pol:vi:other:cat":        "#777777",
      "pol:vi:dontknow:cat":     "#CCCCCC",
      "pol:vi:restore:cat":     "#000080",
    },
    // Vote share is a share of VOTERS, not of all adults: average it over
    // n_voters so a constituency contributes in proportion to its likely-voter
    // weight. Drives both the SQL denominator and every frontend roll-up
    // (see utils/keyWeights.js).
    weightColumn: "n_voters",
    schema: "tracking",
    waves: [2,3,4,5]
  },

  turnout: {
    type: "",
    label: "Turnout",
    category: "political",
    fulltext: "If a General Election were held tomorrow, how likely would you be to vote?",
    client: "all",
    keys: [
      "pol:turnout:turnout"
    ],
    labels: {
      "pol:turnout:turnout": "Turnout"
    },
    colors: {
      "pol:turnout:turnout": "#808080"
    },
    schema: "tracking",
    waves: [2,3]
  },

  // past_vote_turnout: {
  //   type: "",
  //   label: "Past vote turnout",
  //   fulltext: "Did you vote in the last General Election (2024)?",
  //   client: "all",
  //   keys: [
  //     "pol:pastvoteturnout:turnout"
  //   ],
  //   labels: {
  //     "pol:pastvoteturnout:turnout": "Turnout"
  //   },
  //   colors: {
  //     "pol:pastvoteturnout:turnout": "#808080"
  //   },
  //   schema: "tracking",
  //   waves: [1, 2]
  // },

  // --- BEST PM ---
  best_pm: {
    type: "categorical",
    label: "Best Prime Minister",
    category: "political",
    fulltext: "Which of the following do you think would make the best Prime Minister?",
    client: "all",
    keys: [
      "pol:best_pm:keir:cat",
      "pol:best_pm:kemi:cat",
      "pol:best_pm:burnham:cat",
      "pol:best_pm:ed:cat",
      "pol:best_pm:farage:cat",
      "pol:best_pm:dk:cat",
      "pol:best_pm:none:cat",
      "pol:best_pm:polanski:cat",
      "pol:best_pm:lowe:cat"
    ],
    labels: {
      "pol:best_pm:keir:cat": "Keir Starmer",
      "pol:best_pm:burnham:cat":   "Andy Burnham",
      "pol:best_pm:kemi:cat": "Kemi Badenoch",
      "pol:best_pm:ed:cat": "Ed Davey",
      "pol:best_pm:farage:cat": "Nigel Farage",
      "pol:best_pm:dk:cat": "Don't know",
      "pol:best_pm:none:cat": "None of the above",
      "pol:best_pm:polanski:cat":"Zack Polanski",
      "pol:best_pm:lowe:cat":   "Rupert Lowe",
    },
    colors: {
      "pol:best_pm:keir:cat":   "#D50000",
      "pol:best_pm:burnham:cat":   "#D50000",
      "pol:best_pm:kemi:cat":   "#0087DC",
      "pol:best_pm:ed:cat":     "#FDBB30",
      "pol:best_pm:farage:cat": "#12B6CF",
      "pol:best_pm:dk:cat":     "#CCCCCC",
      "pol:best_pm:none:cat":   "#9E9E9E",
      "pol:best_pm:polanski:cat":   "#008066",
      "pol:best_pm:lowe:cat":   "#000080",
    },
    // Same basis as vote intention — a best-PM preference is read as a
    // voters' figure, so it is averaged over n_voters rather than n_raked.
    weightColumn: "n_voters",
    schema: "tracking",
    waves: [2,3,4,5]
  },

  // --- NATIONAL ISSUES ---
  national_issues: {
    type: "categorical",
    label: "Most important national issues",
    category: "political",
    fulltext: "In your view, which of the following are the most important issues facing the UK at the moment? Please select up to three issues.",
    client: "all",
    keys: [
      "pol:nat_issues:economic_growth:cat",
      "pol:nat_issues:col:cat",
      "pol:nat_issues:jobs:cat",
      "pol:nat_issues:health:cat",
      "pol:nat_issues:immigration:cat",
      "pol:nat_issues:crime:cat",
      "pol:nat_issues:personal_tax:cat",
      "pol:nat_issues:pension:cat",
      "pol:nat_issues:education:cat",
      "pol:nat_issues:housing:cat",
      "pol:nat_issues:environment:cat",
      "pol:nat_issues:transport:cat",
      "pol:nat_issues:welfare:cat",
      "pol:nat_issues:defence:cat",
      "pol:nat_issues:foreign:cat",
      "pol:nat_issues:social:cat",
      "pol:nat_issues:none:cat",
    ],
    labels: {
      "pol:nat_issues:economic_growth:cat": "Economic growth",
      "pol:nat_issues:col:cat": "Cost of living",
      "pol:nat_issues:jobs:cat": "Jobs & employment",
      "pol:nat_issues:health:cat": "Health & the NHS",
      "pol:nat_issues:immigration:cat": "Immigration & asylum",
      "pol:nat_issues:crime:cat": "Crime & policing",
      "pol:nat_issues:personal_tax:cat": "Levels of personal taxation",
      "pol:nat_issues:pension:cat": "Pensions",
      "pol:nat_issues:education:cat": "Education",
      "pol:nat_issues:housing:cat": "Housing",
      "pol:nat_issues:environment:cat": "Environment & climate change",
      "pol:nat_issues:transport:cat": "Transport & infrastructure",
      "pol:nat_issues:welfare:cat": "Welfare & benefits",
      "pol:nat_issues:defence:cat": "Defence & national security",
      "pol:nat_issues:foreign:cat": "Foreign policy",
      "pol:nat_issues:social:cat": "Social & cultural issues",
      "pol:nat_issues:none:cat": "None of these",
    },
    colors: {
      "pol:nat_issues:economic_growth:cat": "#1E88E5",
      "pol:nat_issues:col:cat":             "#F57C00",
      "pol:nat_issues:jobs:cat":            "#F9A825",
      "pol:nat_issues:health:cat":          "#D81B60",
      "pol:nat_issues:immigration:cat":     "#8E24AA",
      "pol:nat_issues:crime:cat":           "#C62828",
      "pol:nat_issues:personal_tax:cat":    "#B71C1C",
      "pol:nat_issues:pension:cat":         "#6D4C41",
      "pol:nat_issues:education:cat":       "#3949AB",
      "pol:nat_issues:housing:cat":         "#00ACC1",
      "pol:nat_issues:environment:cat":     "#2E7D32",
      "pol:nat_issues:transport:cat":       "#00897B",
      "pol:nat_issues:welfare:cat":         "#7CB342",
      "pol:nat_issues:defence:cat":         "#37474F",
      "pol:nat_issues:foreign:cat":         "#FDD835",
      "pol:nat_issues:social:cat":          "#F06292",
      "pol:nat_issues:none:cat":            "#9E9E9E",
    },
    schema: "tracking",
    waves: [1, 2,3,4,5]
  },

  // --- LOCAL ISSUES ---
  local_issues: {
    type: "categorical",
    label: "Most important local issues",
    category: "political",
    fulltext: "In your view, which of the following are the most important issues in your local area at the moment? Please select up to three issues.",
    client: "all",
    keys: [
      "pol:loc_issues:economic_growth:cat",
      "pol:loc_issues:col:cat",
      "pol:loc_issues:jobs:cat",
      "pol:loc_issues:health:cat",
      "pol:loc_issues:immigration:cat",
      "pol:loc_issues:crime:cat",
      "pol:loc_issues:personal_tax:cat",
      "pol:loc_issues:pension:cat",
      "pol:loc_issues:education:cat",
      "pol:loc_issues:housing:cat",
      "pol:loc_issues:environment:cat",
      "pol:loc_issues:transport:cat",
      "pol:loc_issues:welfare:cat",
      "pol:loc_issues:defence:cat",
      "pol:loc_issues:foreign:cat",
      "pol:loc_issues:social:cat",
      "pol:loc_issues:none:cat",
    ],
    labels: {
      "pol:loc_issues:economic_growth:cat": "Economic growth",
      "pol:loc_issues:col:cat": "Cost of living",
      "pol:loc_issues:jobs:cat": "Jobs & employment",
      "pol:loc_issues:health:cat": "Health & the NHS",
      "pol:loc_issues:immigration:cat": "Immigration & asylum",
      "pol:loc_issues:crime:cat": "Crime & policing",
      "pol:loc_issues:personal_tax:cat": "Levels of personal taxation",
      "pol:loc_issues:pension:cat": "Pensions",
      "pol:loc_issues:education:cat": "Education",
      "pol:loc_issues:housing:cat": "Housing",
      "pol:loc_issues:environment:cat": "Environment & climate change",
      "pol:loc_issues:transport:cat": "Transport & infrastructure",
      "pol:loc_issues:welfare:cat": "Welfare & benefits",
      "pol:loc_issues:defence:cat": "Defence & national security",
      "pol:loc_issues:foreign:cat": "Foreign policy",
      "pol:loc_issues:social:cat": "Social & cultural issues",
      "pol:loc_issues:none:cat": "None of these",
    },
    colors: {
      "pol:loc_issues:economic_growth:cat": "#1E88E5",
      "pol:loc_issues:col:cat":             "#F57C00",
      "pol:loc_issues:jobs:cat":            "#F9A825",
      "pol:loc_issues:health:cat":          "#D81B60",
      "pol:loc_issues:immigration:cat":     "#8E24AA",
      "pol:loc_issues:crime:cat":           "#C62828",
      "pol:loc_issues:personal_tax:cat":    "#B71C1C",
      "pol:loc_issues:pension:cat":         "#6D4C41",
      "pol:loc_issues:education:cat":       "#3949AB",
      "pol:loc_issues:housing:cat":         "#00ACC1",
      "pol:loc_issues:environment:cat":     "#2E7D32",
      "pol:loc_issues:transport:cat":       "#00897B",
      "pol:loc_issues:welfare:cat":         "#7CB342",
      "pol:loc_issues:defence:cat":         "#37474F",
      "pol:loc_issues:foreign:cat":         "#FDD835",
      "pol:loc_issues:social:cat":          "#F06292",
      "pol:loc_issues:none:cat":            "#9E9E9E",
    },
    schema: "tracking",
    waves: [2,3,4,5]
  },

  // --- LOCAL PRIORITIES ---
  priorities: {
    type: "categorical",
    label: "Local priorities",
    category: "political",
    fulltext: "Imagine there was going to be major investment to address 3 things. Please select the 3 things you would prioritise.",
    client: "all",
    keys: [
      "pol:priorities:facilities:cat",
      "pol:priorities:safety:cat",
      "pol:priorities:services:cat",
      "pol:priorities:housing:cat",
      "pol:priorities:employment:cat",
      "pol:priorities:transport:cat",
      "pol:priorities:entertainment:cat",
      "pol:priorities:environment:cat",
    ],
    labels: {
      "pol:priorities:facilities:cat": "Facilities for the community",
      "pol:priorities:safety:cat": "Safety and policing",
      "pol:priorities:services:cat": "Public services",
      "pol:priorities:housing:cat": "Housing",
      "pol:priorities:employment:cat": "Employment opportunities",
      "pol:priorities:transport:cat": "Transport and travel",
      "pol:priorities:entertainment:cat": "Entertainment and shopping",
      "pol:priorities:environment:cat": "Local environment",
    },
    colors: {
      "pol:priorities:facilities:cat":    "#8E24AA",
      "pol:priorities:safety:cat":        "#E53935",
      "pol:priorities:services:cat":      "#3949AB",
      "pol:priorities:housing:cat":       "#FB8C00",
      "pol:priorities:employment:cat":    "#1E88E5",
      "pol:priorities:transport:cat":     "#00ACC1",
      "pol:priorities:entertainment:cat": "#F4511E",
      "pol:priorities:environment:cat":   "#43A047",
    },
    schema: "tracking",
    waves: [2,3]
  },

  // --- AMENITIES ---
  amenities: {
    type: "categorical",
    label: "Valued amenities",
    category: "political",
    fulltext: "Which of the following would you most like to see more of nearby, to improve your local area and make it a better place to live? Please rank your top three options.",
    client: "all",
    keys: [
      "pol:amenities:supermarket:cat",
      "pol:amenities:specialist:cat",
      "pol:amenities:clothes:cat",
      "pol:amenities:independents:cat",
      "pol:amenities:restaurants:cat",
      "pol:amenities:highstreets:cat",
      "pol:amenities:greenspaces:cat",
      "pol:amenities:libraries_spaces:cat",
      "pol:amenities:community_spaces:cat",
      "pol:amenities:playgrounds:cat",
      "pol:amenities:outdoor_exerise:cat",
      "pol:amenities:indoor_exercise:cat",
    ],
    labels: {
      "pol:amenities:supermarket:cat": "Supermarkets",
      "pol:amenities:specialist:cat": "Specialist food shops",
      "pol:amenities:clothes:cat": "Clothes shops",
      "pol:amenities:independents:cat": "Independently owned shops",
      "pol:amenities:restaurants:cat": "Restaurants and cafés",
      "pol:amenities:highstreets:cat": "High street improvements",
      "pol:amenities:greenspaces:cat": "Open green space",
      "pol:amenities:libraries_spaces:cat": "Libraries",
      "pol:amenities:community_spaces:cat": "Community spaces",
      "pol:amenities:playgrounds:cat": "Children's playground",
      "pol:amenities:outdoor_exerise:cat": "Outdoor exercise area and equipment",
      "pol:amenities:indoor_exercise:cat": "Indoor exercise facility",
    },
    colors: {
      "pol:amenities:supermarket:cat":       "#F59E0B",
      "pol:amenities:specialist:cat":        "#06B6D4",
      "pol:amenities:clothes:cat":           "#F97316",
      "pol:amenities:independents:cat":      "#8B5CF6",
      "pol:amenities:restaurants:cat":       "#EF4444",
      "pol:amenities:highstreets:cat":       "#D97706",
      "pol:amenities:greenspaces:cat":       "#10B981",
      "pol:amenities:libraries_spaces:cat":  "#6366F1",
      "pol:amenities:community_spaces:cat":  "#3B82F6",
      "pol:amenities:playgrounds:cat":       "#EC4899",
      "pol:amenities:outdoor_exerise:cat":   "#22C55E",
      "pol:amenities:indoor_exercise:cat":   "#84CC16",
    },
    schema: "tracking",
    waves: [2,3]
  },

  // --- PAST VOTE ---
  past_vote: {
    type: "categorical",
    label: "Past vote (2024)",
    category: "political",
    fulltext: "Which party did you vote for in the last General Election (2024)?",
    client: "all",
    keys: [
      "pol:pastvote:conservative:cat",
      "pol:pastvote:labour:cat",
      "pol:pastvote:libdem:cat",
      "pol:pastvote:reform:cat",
      "pol:pastvote:green:cat",
      "pol:pastvote:snp:cat",
      "pol:pastvote:plaidcymru:cat",
      "pol:pastvote:independent_other:cat",
    ],
    labels: {
      "pol:pastvote:conservative:cat": "Conservative",
      "pol:pastvote:labour:cat": "Labour",
      "pol:pastvote:libdem:cat": "Liberal Democrat",
      "pol:pastvote:reform:cat": "Reform UK",
      "pol:pastvote:green:cat": "Green",
      "pol:pastvote:snp:cat": "SNP",
      "pol:pastvote:plaidcymru:cat": "Plaid Cymru",
      "pol:pastvote:independent_other:cat": "Independent / Other",
    },
    colors: {
      "pol:pastvote:conservative:cat":      "#0087DC",
      "pol:pastvote:labour:cat":            "#D50000",
      "pol:pastvote:libdem:cat":            "#FDBB30",
      "pol:pastvote:reform:cat":            "#12B6CF",
      "pol:pastvote:green:cat":             "#008066",
      "pol:pastvote:snp:cat":               "#FFF95D",
      "pol:pastvote:plaidcymru:cat":        "#3F8428",
      "pol:pastvote:independent_other:cat": "#777777",
    },
    schema: "single",
    normalise_over_options: true,
  },
};
